/* eslint-disable @next/next/no-img-element */
import { Icon, useResponsive } from '@aptuno/aptuno-ui';
import { formatMoney } from '@shared/utils/format-money';
import React, { FC, useEffect, useState } from 'react';
import {
  CharacteristicItem,
  Characteristics,
  CompactEstateCardStyled,
  CompactImageCard,
  InfoBox,
  Price,
  TitleCard,
} from './CompactEstateCard.styled';
export type CompactEstateCardProps = {
  imageUrl: string;
  title: string;
  price: number;
  administatrionFee?: number;
  rooms: number;
  bathrooms: number;
  squareMeters: number;
};

const CompactEstateCard: FC<CompactEstateCardProps> = (props) => {
  const { isMobile } = useResponsive();
  const [imageSize, setImageSize] = useState(88);
  useEffect(() => {
    if (isMobile) setImageSize(88);
    else setImageSize(120);
  }, [isMobile]);

  return (
    <CompactEstateCardStyled>
      <CompactImageCard width={imageSize} height={imageSize}>
        <img src={props.imageUrl} alt={props.title} />
      </CompactImageCard>
      <InfoBox>
        <TitleCard>{props.title}</TitleCard>
        <Price>
          {'$' + formatMoney(props.price + Number(props.administatrionFee || 0))}
          {props.administatrionFee && <span>/admon. incluída</span>}
        </Price>
        <Characteristics>
          <CharacteristicItem>
            <Icon icon={'bed'} width={'16px'} height={'16px'} />{props.rooms}
          </CharacteristicItem>
          <CharacteristicItem>
            <Icon icon={'bath'} width={'16px'} height={'16px'} />{props.bathrooms}
          </CharacteristicItem>
          <CharacteristicItem>
            <Icon icon={'squarem'} width={'16px'} height={'16px'}  />{props.squareMeters} m2
          </CharacteristicItem>
        </Characteristics>
      </InfoBox>
    </CompactEstateCardStyled>
  );
};

export { CompactEstateCard };
